export default class FantasyPlayerStatsModel {
  public key: string = null;
  public label: string = null;
  public value: number = null;
}
